webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    var form = (0, _jquery2.default)('#id_question_form');

    (0, _jquery2.default)('input[name="captcha_1"]', form).addClass('form-control').css('display', 'block');
    (0, _jquery2.default)('img.captcha').css('margin', '20px 0');
    form.validate();
});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(3);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    var $banners = (0, _jquery2.default)('.banners-owl-carousel');
    if ($banners.length) {
        $banners.owlCarousel({
            loop: true,
            nav: true,
            responsiveClass: true,
            margin: 40,
            responsive: {
                1200: {
                    items: 4,
                    nav: true,
                    loop: true
                },
                1024: {
                    items: 3,
                    nav: true,
                    loop: true
                },
                640: {
                    items: 2,
                    nav: true,
                    loop: true
                },
                0: {
                    items: 1,
                    nav: true,
                    loop: true
                }

            }
        });
    }
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(32);

__webpack_require__(27);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $menu = (0, _jquery2.default)('.top-menu'),
    $menu_wrapper = (0, _jquery2.default)('.top-menu-wrapper'),
    $menu_switcher = (0, _jquery2.default)('#id_mobile_menu'),
    $ul = $menu_wrapper.children('ul'),
    resizeMenu = function resizeMenu() {
    (0, _jquery2.default)('li', $menu).off('mouseover');
    (0, _jquery2.default)('li', $menu).off('mouseleave');
    $ul.children('li').children('ul').hide();

    if ((0, _jquery2.default)(window).width() > 991) {
        $menu_wrapper.show();
        $ul.children('li').mouseover(function (e) {
            e.preventDefault();
            (0, _jquery2.default)(this).children('ul').fadeIn(10);
        });
        $ul.children('li').mouseleave(function (e) {
            e.preventDefault();
            (0, _jquery2.default)(this).children('ul').fadeOut(10);
        });
    } else {
        $menu_wrapper.hide();
        $ul.children('li').off('click');
        (0, _jquery2.default)('> li', $ul).click(function (e) {
            e.preventDefault();
            if ((0, _jquery2.default)(this).children('ul').is(':visible')) {
                window.location.href = (0, _jquery2.default)('a', this).attr('href');
            } else {
                $ul.children('li').children('ul').slideUp();
                (0, _jquery2.default)(this).children('ul').slideToggle();
            }
        }).find('li').click(function (e) {
            e.stopPropagation();
        });
    }
};

if ($menu.length) {
    $menu_switcher.click(function (e) {
        e.preventDefault();
        $ul.children('li').children('ul').hide();
        $menu_wrapper.slideToggle();
    });
    resizeMenu();
    (0, _jquery2.default)(window).resize(function () {
        return resizeMenu();
    });
}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $button = (0, _jquery2.default)('#id_head_search_btn'),
    $input = (0, _jquery2.default)('#id_head_search_input'),
    $form = (0, _jquery2.default)('#id_head_search_form');

if ($button.length) {
    $button.click(function (e) {
        e.preventDefault();
        $form.slideToggle();
        $input.focus();
    });
    (0, _jquery2.default)('.search-close').click(function (e) {
        e.preventDefault();
        $form.slideUp();
    });
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(33);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(41);

__webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    var $sel2 = (0, _jquery2.default)('.js-select2'),
        url = $sel2.data('url');
    $sel2.select2({
        language: 'ru',
        allowClear: true,
        placeholder: {
            id: -1,
            text: 'Выберите адрес...',
            selected: 'selected'
        }
    });
    $sel2.select2('val', -1);
    $sel2.on('select2:select', function (e) {
        window.location.href = url + e.params.data.id + '/';
    });
});

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(37);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _knockout = __webpack_require__(38);

var _knockout2 = _interopRequireDefault(_knockout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    var specialVersionToggle = (0, _jquery2.default)('#id-special-version-toggle'),
        specialVersionControlBar = (0, _jquery2.default)('#id-special-version-control-bar');

    function SpecialVersionToggleViewModel() {
        var self = this;

        self.cookie_key = 'fkr_special_version';
        self.isSpecialVersion = _jquery2.default.cookie(self.cookie_key) === 'true';

        self.toggleSpecialVersion = function () {
            _jquery2.default.cookie(self.cookie_key, !self.isSpecialVersion, { path: '/' });
            window.location.reload();
        };

        self.initSpecialVersion = function () {
            (0, _jquery2.default)('body').css('visibility', 'visible');
            (0, _jquery2.default)('span', specialVersionToggle).html('Обычная версия');
        };

        if (self.isSpecialVersion) {
            self.initSpecialVersion();
        }
    }

    function SpecialVersionControlBarViewModel() {
        var self = this;

        self.defaults = {
            font_size: '14px',
            letter_spacing: 'normal'
        };

        self.cookie_key = 'fkr_special_version_data';
        self.data = _jquery2.default.cookie(self.cookie_key);
        self.elements = (0, _jquery2.default)('#id_wrapper *');

        self.letterSpacing = _knockout2.default.observable();

        if (self.data) {
            self.parsed = JSON.parse(self.data);
        } else {
            self.parsed = self.defaults;
        }

        /**
         * Storing params in cookies in JSON string.
         */
        self.storeCookie = function () {
            _jquery2.default.cookie(self.cookie_key, JSON.stringify(self.parsed));
        };

        /**
         * Font size related.
         */
        self.changeFontSize = function (font_size) {
            if (font_size) {
                self.parsed.font_size = font_size;
                self.storeCookie();
            }

            self.elements.css('font-size', self.parsed.font_size, 'important');
        };

        if (_jquery2.default.cookie('fkr_special_version') === 'true') {
            self.letterSpacing.subscribe(function (value) {
                self.parsed.letter_spacing = value;
                self.elements.css('letter-spacing', value, 'important');
                self.storeCookie();
            });
            self.letterSpacing(self.parsed.letter_spacing);

            self.changeFontSize();
        }
    }

    _knockout2.default.applyBindings(new SpecialVersionToggleViewModel(), specialVersionToggle[0]);
    _knockout2.default.applyBindings(new SpecialVersionControlBarViewModel(), specialVersionControlBar[0]);
});

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    var docSerachForm = (0, _jquery2.default)('.docs-search-form');

    (0, _jquery2.default)('.date', docSerachForm).datepicker({
        language: 'ru'
    });
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $form = (0, _jquery2.default)('#id_question_form');

if ($form.length) {
    window.ymaps.ready(function () {
        new window.ymaps.SuggestView('id_address');
    });
}

$form.validate();

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ymap = (0, _jquery2.default)('#id_map');

if ($ymap.length) {
    window.ymaps.ready(function () {
        var myMap = new window.ymaps.Map('id_map', {
            center: [56.0, 94.0],
            zoom: 6,
            controls: ['zoomControl', 'geolocationControl']
        }),
            $map = (0, _jquery2.default)('#id_map'),
            $notice = (0, _jquery2.default)('#id_map_notice'),
            $but = (0, _jquery2.default)('#id_map_search_but'),
            $str = (0, _jquery2.default)('#id_map_search_str'),
            $data_map = (0, _jquery2.default)('#id_data_map'),
            $show_map_link = (0, _jquery2.default)('.js-show-map'),
            $hide_map_link = (0, _jquery2.default)('.js-hide-map'),
            objectManager = new window.ymaps.ObjectManager({
            clusterize: true,
            gridSize: 32,
            clusterDisableClickZoom: false
        }),
            loadBalloonData = function loadBalloonData(objectId) {
            var dataDeferred = window.ymaps.vow.defer();
            _jquery2.default.ajax({
                url: $map.data('detail-url'),
                data: { id: objectId }
            }).done(function (data) {
                return dataDeferred.resolve(data);
            });
            return dataDeferred.promise();
        },
            hasBalloonData = function hasBalloonData(objectId) {
            return objectManager.objects.getById(objectId).properties.balloonContent;
        },
            openBalloon = function openBalloon(objectId) {
            var obj = objectManager.objects.getById(objectId);

            $notice.slideUp();

            if (hasBalloonData(objectId)) {
                objectManager.objects.balloon.open(objectId);
            } else {
                obj.properties.balloonContent = 'Идет загрузка данных...';
                objectManager.objects.balloon.open(objectId);
                loadBalloonData(objectId).then(function (data) {
                    obj.properties.balloonContentHeader = data.balloonContentHeader;
                    obj.properties.balloonContentBody = data.balloonContentBody;
                    obj.properties.balloonContentFooter = data.balloonContentFooter;
                    objectManager.objects.balloon.setData(obj);
                });
            }
        },
            moveTo = function moveTo(objectId) {
            var obj = objectManager.objects.getById(objectId);

            myMap.panTo([obj.geometry.coordinates[0], obj.geometry.coordinates[1]], {
                duration: 1000
            }).then(function () {
                myMap.setZoom(17, {
                    duration: 1000
                }).then(function () {
                    return openBalloon(objectId);
                });
            });
        },
            showError = function showError(message) {
            $notice.text(message);
            $str.addClass('input_error');
            $notice.css('display', 'block');
        },
            showResult = function showResult(geo_obj) {
            _jquery2.default.ajax({
                url: $map.data('search-url'),
                data: { lat: geo_obj.geometry.getCoordinates()[0], lon: geo_obj.geometry.getCoordinates()[1] }
            }).done(function (data) {
                if (data.house) {
                    moveTo(data.house);
                    $str.removeClass('input_error');
                } else {
                    showError('Нет данных о ремонте в данном доме.');
                }
            });
        },
            geocode = function geocode() {
            var request = (0, _jquery2.default)('#id_map_search_str').val();

            // Геокодируем введённые данные.
            window.ymaps.geocode(request).then(function (res) {
                var obj = res.geoObjects.get(0);
                var error = void 0;

                if (obj) {
                    // Об оценке точности ответа геокодера можно прочитать тут:
                    // https://tech.yandex.ru/maps/doc/geocoder/desc/reference/precision-docpage/
                    switch (obj.properties.get('metaDataProperty.GeocoderMetaData.precision')) {
                        case 'exact':
                            break;
                        case 'number':
                        case 'near':
                        case 'range':
                            error = 'Неточный адрес, требуется уточнение. Уточните номер дома.';
                            break;
                        case 'street':
                            error = 'Неполный адрес, требуется уточнение. Уточните номер дома.';
                            break;
                        case 'other':
                        default:
                            error = 'Неточный адрес, требуется уточнение. Уточните адрес.';
                    }
                } else {
                    error = 'Адрес не найден. Уточните адрес.';
                }

                // Если геокодер возвращает пустой массив или неточный результат, то показываем ошибку.
                if (error) {
                    showError(error);
                } else {
                    showResult(obj);
                }
            }, function (e) {
                console.log(e);
            });
        },
            showMap = function showMap() {
            $show_map_link.fadeOut();
            $map.slideDown(function () {
                return $hide_map_link.fadeIn();
            });
        },
            hideMap = function hideMap() {
            $hide_map_link.fadeOut();
            $map.slideUp(function () {
                return $show_map_link.fadeIn();
            });
        };

        if ($data_map.length && $data_map.data('hidden') === true) {
            $hide_map_link.hide();
            $map.hide(function () {
                return $show_map_link.show();
            });
        }

        myMap.behaviors.disable('scrollZoom');
        new window.ymaps.SuggestView('id_map_search_str');

        objectManager.objects.events.add('click', function (e) {
            return openBalloon(e.get('objectId'));
        });
        objectManager.objects.options.set('preset', 'islands#blueDotIcon');
        objectManager.clusters.options.set('preset', 'islands#blueClusterIcons');
        myMap.geoObjects.add(objectManager);

        $but.click(function (e) {
            e.preventDefault();
            if (!$map.is(':visible')) showMap(e);
            geocode();
        });
        (0, _jquery2.default)(document).keypress(function (e) {
            if (e.which === 13) {
                if (!$map.is(':visible')) showMap(e);
                geocode();
            }
        });

        _jquery2.default.ajax({
            url: $map.data('list-url')
        }).done(function (data) {
            objectManager.add(data);
            var sel = $data_map.data('selected');
            if ($data_map.length && sel) {
                moveTo(sel);
            }
        });

        $show_map_link.click(function (e) {
            e.preventDefault();
            showMap(e);
        });

        $hide_map_link.click(function (e) {
            e.preventDefault();
            hideMap(e);
        });
    });
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(3);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    var $slider = (0, _jquery2.default)('.slider-owl-carousel');
    if ($slider.length) {
        $slider.owlCarousel({
            loop: true,
            margin: 0,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                    nav: true,
                    loop: true
                }
            }
        });
    }
});

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(21);

__webpack_require__(19);

__webpack_require__(22);

__webpack_require__(23);

__webpack_require__(18);

__webpack_require__(2);

__webpack_require__(25);

__webpack_require__(24);

__webpack_require__(16);

__webpack_require__(17);

__webpack_require__(26);

__webpack_require__(8);

__webpack_require__(9);

__webpack_require__(6);

__webpack_require__(10);

__webpack_require__(7);

__webpack_require__(11);

__webpack_require__(14);

__webpack_require__(15);

__webpack_require__(13);

__webpack_require__(5);

__webpack_require__(12);

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports) {

module.exports = "../media/link_bg.png";

/***/ })
],[28]);


// WEBPACK FOOTER //
// js/main.js